/* ============================================================
   artvision® · Künstlerprofil · Sprungnavigation
   Übernimmt die Mechanik der alten anchor-link-navigation:
   Klick scrollt weich zum Anker, der aktive Zustand folgt beim
   Scrollen mit. Das Anheften macht CSS (position: sticky) —
   der alte Platzhalter-Trick per JS ist dafür nicht nötig.
   ============================================================ */
(function () {
  function init(nav) {
    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-av-nav-link]'));
    if (!links.length) return;

    var targets = links.map(function (link) {
      var href = link.getAttribute('href') || '';
      return href.charAt(0) === '#' ? document.querySelector(href) : null;
    });

    function headerHeight() {
      return window.innerWidth <= 749 ? 64 : 74;
    }

    function scrollOffset() {
      return headerHeight() + nav.offsetHeight + 16;
    }

    function setActive(index) {
      links.forEach(function (link, i) {
        var on = i === index;
        link.classList.toggle('av-ar-nav__link--active', on);
        if (on) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    links.forEach(function (link, i) {
      link.addEventListener('click', function (event) {
        var target = targets[i];
        if (!target) return;
        event.preventDefault();
        setActive(i);
        var top = target.getBoundingClientRect().top + window.pageYOffset - scrollOffset();
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    var ticking = false;

    function sync() {
      ticking = false;
      var line = scrollOffset() + 8;
      var active = 0;
      targets.forEach(function (target, i) {
        if (target && target.getBoundingClientRect().top <= line) active = i;
      });
      setActive(active);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-av-ar-nav]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
